module.exports = __webpack_public_path__ + "static/floralbath2-461bd457f9803acb02d266c3bcb7a6ec.png";